import { lazy } from "react";

export default function icons() {
  return {
    Logo: lazy(() => import("./logo")),
    FacebookIcon: lazy(() => import("./social-icons/FacebookIcon")),
    LinkedInIcon: lazy(() => import("./social-icons/LinkedInIcon")),
    InstagramIcon: lazy(() => import("./social-icons/InstagramIcon")),
    TikTokIcon: lazy(() => import("./social-icons/TikTokIcon")),
    XIcon: lazy(() => import("./social-icons/XIcon")),
    GoogleIcon: lazy(() => import("./social-icons/GoogleIcon")),
    AppleIcon: lazy(() => import("./social-icons/AppleIcon")),
  };
}
